import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/deepquery.png";
import emotion from "../../Assets/Projects/paperpal.png";
import editor from "../../Assets/Projects/ocular.png";
import chatify from "../../Assets/Projects/stockpredictor.png";
//import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/disha.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Face Recognition Attendance System"
              description="A facial recognition-based attendance system that automatically marks attendance from individual and group photos using Face Analysis and RESTful APIs."
              ghLink="https://github.com/Mohitbkd/Face_Recognition_Attendance_System"
              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Automobile Price Prediction"
              description="Build a model to understand the factors that drive the car of the price. This will help your automobile company launch their new car in the market effectively by pricing it better."
              ghLink="https://github.com/Mohitbkd/Automobile_Price_Prediction"
              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Predict Loan Eligibility for Housing Finance Company"
              description="Predict Loan Eligibility for Dream Housing Finance company Dream Housing Finance company deals in all kinds of home loans. They have presence across all urban, semi urban and rural areas."
              ghLinkLink="https://github.com/Mohitbkd/Predict_Loan_Eligibility_for_Housing_Finance_Company"
                           
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Bank Marketing Prediction"
              description="Made a predictive model to predict if the customer will respond positively to the campaign or not"
              ghLink="https://github.com/Mohitbkd/Bank_Marketing_Prediction"
              // demoLink="https://deepquery.onrender.com/"
            />
          </Col>

          

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Google Playstore App Rating"
              description="Analyzing factors influencing app performance on the Google Play Store to boost visibility and recommendations."
              ghLink="https://paperpal-q4gw.onrender.com/"
               
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
